import { useEffect, useState } from "react";
import { getCurrentPath } from "../utils/get-params-value";

/**
 * Custom hook to manage active menu item based on current pathname
 * @param {Array} sideBarMenuItem - Array of menu items with href properties
 * @returns {number} activeTabIndex - Index of the currently active menu item
 */
export const useActiveMenuItem = (sideBarMenuItem = []) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const pathName = getCurrentPath();

  useEffect(() => {
    const index = sideBarMenuItem.findIndex((item) =>
      pathName.includes(item.href)
    );
    if (index === -1) {
      setActiveTabIndex(0);
    } else {
      setActiveTabIndex(index);
    }
  }, [pathName, sideBarMenuItem]);

  return activeTabIndex;
};
